import React from 'react';
import Icon from '../../../components/AppIcon';

const UserStatsCards = ({ stats }) => {
  const cards = [
    {
      label: 'Total Users',
      value: stats?.totalUsers || 0,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    },
    {
      label: 'Active Users',
      value: stats?.activeUsers || 0,
      icon: 'UserCheck',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      label: 'Inactive Users',
      value: stats?.inactiveUsers || 0,
      icon: 'UserX',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Admin Users',
      value: stats?.adminUsers || 0,
      icon: 'Shield',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards?.map((card, index) => (
        <div
          key={index}
          className={`bg-card border-2 ${card?.borderColor} rounded-lg p-6 shadow-elevation-2 hover:shadow-elevation-3 transition-all duration-200`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${card?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
          <h3 className="text-3xl font-bold text-foreground mb-1">{card?.value}</h3>
          <p className="text-sm text-muted-foreground">{card?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default UserStatsCards;